import {useEffect, useState} from "react";

export default function useCountdown(initialSeconds: number) {
    const [countdown, setCountdown] = useState(initialSeconds);

    useEffect(() => {
        if (countdown <= 0) {
            return;
        }
        const interval = setInterval(() => {
            setCountdown(countdown - 1);
        }, 1000);

        return () => clearInterval(interval);
    }, [countdown]);


    return { countdown };
}

export function useCountdownWithDate(date: Date | null) {
    if (!date) {
        return { countdown: 0 };
    }
    // const timezoneOffset = date.getTimezoneOffset() * 60;
    const [countdown, setCountdown] = useState(Math.floor((((date.getTime() - new Date().getTime())) / 1000)));

    useEffect(() => {
        if (countdown <= 0) {
            return;
        }
        const interval = setInterval(() => {
            setCountdown(Math.floor((((date.getTime() - new Date().getTime())) / 1000)));
        }, 1000);

        return () => clearInterval(interval);
    }, [countdown]);


    return { countdown };
}
